import React from 'react'
import ReactDOM from 'react-dom'
import { Clear } from 'images/icons'

const modalRoot = document.getElementById('modal-root')

interface IProps {
  open: boolean
  onClose: () => void
  headline?: string
  big?: boolean
}

interface IState {
  isVisible: boolean
}

class Modal extends React.Component<IProps, IState> {
  private el: HTMLDivElement

  constructor(props: any) {
    super(props)
    this.el = document.createElement('div')
  }

  componentDidMount() {
    // The portal element is inserted in the DOM tree after
    // the Modal's children are mounted, meaning that children
    // will be mounted on a detached DOM node. If a child
    // component requires to be attached to the DOM tree
    // immediately when mounted, for example to measure a
    // DOM node, or uses 'autoFocus' in a descendant, add
    // state to Modal and only render the children when Modal
    // is inserted in the DOM tree.
    if (modalRoot) modalRoot.appendChild(this.el)
  }

  componentWillUnmount() {
    if (modalRoot) modalRoot.removeChild(this.el)
  }

  closeModal = () => {
    this.props.onClose()
  }

  render() {
    const { headline, children, open, big } = this.props

    return (
      open &&
      ReactDOM.createPortal(
        <div
          style={{
            backgroundColor: 'rgb(0, 0, 0, 0.5)',
            zIndex: 101,
          }}
          className="w-full h-full fixed top-0 left-0 flex items-center justify-center"
        >
          <div className={`flex flex-col ${big ? 'w-9/12' : 'w-6/12'} bg-white shadow-md`}>
            <div className="self-end p-5">
              <button onClick={this.closeModal}>
                <Clear size={40} />
              </button>
            </div>

            <div className={`${big ? 'px-80 pb-45' : 'p-30'} pt-0`}>
              {headline && <h1 className="h1 mb-25">{headline}</h1>}
              {children}
            </div>
          </div>
        </div>,
        this.el,
      )
    )
  }
}

export default Modal
